import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {FunctionsService} from "../services/functions.service";

@Component({
    selector: 'app-eat-drink-list',
    templateUrl: './eat-drink-list.component.html'
})
export class EatDrinkListComponent implements OnInit {

    public slug;
    readonly rangeSliderValues = ['$', '$$', '$$$'];
    banner_image = './assets/images/banners/eat-drink-banner.jpg';

    category = {
        id: '',
        title: '',
        content: '',
        cover_image: ''
    };
    restaurants = [];

    regions = [];
    allRegions: Array<any>;
    regionsPart: Array<any>;
    regionCollapsed: boolean;
    regionHasMore: boolean;

    categories = [];
    allCategories: Array<any>;
    categoriesPart: Array<any>;
    cateGoryCollapsed: boolean;
    categoryHasMore: boolean;

    facilityGroups = [];
    allFacilities: Array<any>;
    facilitiesPart: Array<any>;

    selected_regions = '';
    selected_facilities = '';
    selected_categories = '';

    max_price = 100000000;
    price_start = 0;
    price_end = 'end';

    checked_categories = [];
    next = null;

    constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private http: HttpClient, public _auth: AuthService) {
        this.allRegions = [];
        this.regionsPart = [];
        this.regionCollapsed = true;
        this.allCategories = [];
        this.categoriesPart = [];
        this.cateGoryCollapsed = true;
        this.allFacilities = [];
        this.facilitiesPart = [];
    }

    ngOnInit() {

        this.route.params.subscribe(params => {
            this.next = null;
            if (params.slug) {
                this.slug = params['slug'];

                this.checked_categories.push(params['slug']);
                this.http.get(Conf.API_URL + '/category-for-restaurant/?slug=' + this.slug).subscribe(
                    data => {
                        this.category = data['results'][0];
                        this.selected_categories = this.category.id;
                        this.getRestaurant();
                    },
                    error => {
                        console.log(error.error)
                    }
                );

            } else {
                this.getRestaurant();
            }

        });

        this.getMaxPrice();
        this.getRegions();
        this.getCategories();
        this.getFacilityGroups();
    }

    getMaxPrice() {
        this.http.get(Conf.API_URL + '/restaurant-max-price/').subscribe(
            data => {
                this.max_price = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    selectCategory(slug) {
        this.slug = slug;
        if (this.checked_categories.indexOf(slug) === -1) {
            this.checked_categories.push(slug);
        } else {
            this.checked_categories.splice($.inArray(slug, this.checked_categories), 1);
        }
        this.selected_categories = $('input[name="category"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        this.getRestaurant()
    }


    getRegions() {
        this.http.get(Conf.API_URL + '/get-joined-areas/?category=eat-drink').subscribe(
            data => {
                this.allRegions = data['results'];
                this.regionHasMore = this.allRegions.length > 10;
                this.regionsPart = JSON.parse(JSON.stringify(this.allRegions)).slice(0, 10);
                this.regions = this.regionsPart;
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getCategories() {
        this.http.get(Conf.API_URL + '/category-for-restaurant/?show_all&count=0').subscribe(
            data => {
                this.allCategories = data['results'];
                this.categoryHasMore = this.allCategories.length > 10;
                this.categoriesPart = JSON.parse(JSON.stringify(this.allCategories)).slice(0, 10);
                this.categories = this.categoriesPart;
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getFacilityGroups() {
        this.http.get(Conf.API_URL + '/restaurant-facility-groups/?show_all&visible=1&count').subscribe(
            data => {
                this.allFacilities = data['results'];
                this.allFacilities.forEach(group => {
                    if (group.facilities.length > 10) {
                        group.collapsed = true;
                        group.hasMore = true;
                    }
                });
                this.facilitiesPart = JSON.parse(JSON.stringify(this.allFacilities));
                this.facilitiesPart.forEach(group => {
                    group.facilities = group.facilities.slice(0, 10);
                });
                this.facilityGroups = this.facilitiesPart;
            },
            error => {
                console.log(error.error)
            }
        );
    }

    choseRegion() {
        this.selected_regions = $('input[name="location"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        this.getRestaurant();
    }

    choseFacility() {
        this.selected_facilities = $('input[name="facility"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        this.getRestaurant();
    }

    choseRange(e) {
        this.price_start = e.from + 1;
        this.price_end = e.to + 1;

        this.getRestaurant();
    }

    getRestaurant() {
        var url = Conf.API_URL + '/restaurants/?category=' + this.selected_categories +
            '&facility=' + this.selected_facilities +
            '&location=' + this.selected_regions;

        if (this.price_end !== 'end') {
            url += '&price_start=' + this.price_start + '&price_end=' + this.price_end;
        }

        this.http.get(url).subscribe(
            data => {
                this.restaurants = data['results'];
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    loadMore() {
        this.http.get(this.next).subscribe(
            data => {
                this.restaurants = this.restaurants.concat(data['results']);
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    firstParagraph(html) {
        return FunctionsService.firstParagraph(html)
    }

    showMore(type: string, facilityGroup?): void {
        switch (type) {
            case 'region': {
                this.regions = this.regionCollapsed ? this.allRegions : this.regionsPart;
                this.regionCollapsed = !this.regionCollapsed;
                break;
            }
            case 'category': {
                this.categories = this.cateGoryCollapsed ? this.allCategories : this.categoriesPart;
                this.cateGoryCollapsed = !this.cateGoryCollapsed;
                break;
            }
            case 'facility': {
                if (facilityGroup) {
                    const group = this.allFacilities.filter(fGroup => fGroup.id === facilityGroup.id);
                    if (facilityGroup.collapsed) {
                        facilityGroup.facilities = group[0].facilities;
                        facilityGroup.collapsed = false;
                    } else {
                        facilityGroup.facilities = facilityGroup.facilities.slice(0, 10);
                        facilityGroup.collapsed = true;
                    }
                }
            }
        }
    }

    getCurrencyByPriceCategory(currency: string, priceCategory: number) {
        return currency.repeat(priceCategory);
    }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/eat-drink-list/eat-drink-list.component.ts